import { IconProps } from '..';

export const PerplexityIcon = ({ className, color = '#13343B' }: IconProps) => {
  return (
    <svg
      width='14'
      height='16'
      viewBox='0 0 14 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.87868 0L6.44361 4.198V0.01H7.33235V4.217L11.9173 0V4.786H13.8V11.689H11.9233V15.951L7.33134 11.925V15.997H6.44261V11.992L1.88369 16V11.69H0V4.785H1.87868V0ZM5.7733 5.662H0.889741V10.813H1.88168V9.188L5.7733 5.662ZM2.77242 9.577V14.045L6.44361 10.818V6.249L2.77242 9.577ZM7.3574 10.775V6.245L11.0296 9.573V11.689H11.0346V14L7.3574 10.776V10.775ZM11.9233 10.813H12.9113V5.663H8.06378L11.9233 9.152V10.813ZM11.0286 4.786V2.016L8.01568 4.786H11.0286ZM5.78031 4.786H2.76741V2.016L5.78031 4.786Z'
        fill={color}
        fillOpacity={1}
      />
    </svg>
  );
};
